import { WeekDay } from '@app-types/index';
import { getTimeSlotForAGivenDay } from '@models/Timetable/functions/setTimeSlotConfiguration/getTimeSlotForAGivenDay';
import { FormatTimeSlotConfigurationsArgs } from '@modules/timetable';
import { timetable_timeslot_configuration_insert_input } from '@app-types/graphql-types';

export const formatTimeSlotConfigurations = ({
  applyToAll,
  timeSlotConfigurationsData,
  week,
  batchId,
  saveAsDefault,
}: FormatTimeSlotConfigurationsArgs): timetable_timeslot_configuration_insert_input[] => {
  const timetableTimeslotConfigurations: timetable_timeslot_configuration_insert_input[] = [];

  if (applyToAll) {
    Object.entries(WeekDay).forEach((weekDay) => {
      timeSlotConfigurationsData.monday.forEach((timeSlotConfiguration) => {
        const timeSlotForAGivenDay = getTimeSlotForAGivenDay({
          week,
          timeSlotConfiguration,
          givenWeekDay: weekDay[0],
        });

        if (timeSlotForAGivenDay) {
          timetableTimeslotConfigurations.push({
            day: weekDay[0],
            startTime: timeSlotForAGivenDay.timeSlot.startTime,
            endTime: timeSlotForAGivenDay.timeSlot.endTime,
            interval: timeSlotConfiguration.interval,
            batchId,
            default: saveAsDefault,
          });
        }
      });
    });
  } else {
    Object.entries(timeSlotConfigurationsData).forEach((timeSlotDayConfiguration) => {
      timeSlotDayConfiguration[1].forEach((timeSlotConfiguration) => {
        const timeSlotForAGivenDay = getTimeSlotForAGivenDay({
          week,
          timeSlotConfiguration,
          givenWeekDay: timeSlotDayConfiguration[0],
        });

        if (timeSlotForAGivenDay) {
          timetableTimeslotConfigurations.push({
            day: timeSlotDayConfiguration[0],
            startTime: timeSlotForAGivenDay.timeSlot.startTime,
            endTime: timeSlotForAGivenDay.timeSlot.endTime,
            interval: timeSlotConfiguration.interval,
            batchId,
            default: saveAsDefault,
          });
        }
      });
    });
  }

  return timetableTimeslotConfigurations;
};
